import {DataFetcher} from '@aboutyou/data-fetcher';
import {FreeDeliverySection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/basket_mov.types';
import {AddItemResponseStatus_Success_Section} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/add_item_status.types';
import React from 'react';
import {useBasketRecommendations} from '../../../features/AddToBasketSuccessFlyout/hooks/useBasketRecommendations';
import {MiniAdpDialogOpenedStateKey} from '../../../features/MiniADPDialog/useMiniAdpDialogOpenedState';
import {BasketFlyoutContentSkeleton} from './BasketFlyoutContentSkeleton';
import {BasketFlyoutContentView} from './BasketFlyoutContentView';

interface BasketFlyoutContentProps {
  productId: number;
  freeDeliverySection?: FreeDeliverySection;
  statusSuccessSections: AddItemResponseStatus_Success_Section[];
  miniADPModalStateManagerKey?: MiniAdpDialogOpenedStateKey;
  basketFlyoutStateManagerKey?: string;
}

export const BasketFlyoutContent: React.FC<
  BasketFlyoutContentProps
> = props => {
  return (
    <DataFetcher
      Loading={BasketFlyoutContentSkeleton}
      Error={null}
      request={useBasketRecommendations({productId: props.productId})}
      View={BasketFlyoutContentView}
      viewProps={{
        freeDeliverySection: props.freeDeliverySection,
        statusSuccessSections: props.statusSuccessSections,
        miniADPModalStateManagerKey: props.miniADPModalStateManagerKey,
        basketFlyoutStateManagerKey: props.basketFlyoutStateManagerKey,
      }}
    />
  );
};
